import axios from "@/plugins/axios";


export default {

    listDebtBases(creditorId, active=true) {

        let params = {}
        if (creditorId) {
            params.creditor_id = creditorId
        }
        params.active = active
        params.limit = 9999
        return axios.httpApi.get("/debt-base", { params });
        
    },

    listDebtNodes(debt_base_id, fields_only=null) {

        let params = {}
        if (debt_base_id) {
            params.debt_base_id = debt_base_id
        }
        if (fields_only) {
            params.fields_only = fields_only
        }
        params.order = "-active"
        params.limit = 9999
        return axios.httpApi.get("/debt-node", { params });
        
    },   

    addDebtBase(data) {
        return axios.httpApi.post("/debt-base", data);
    },

    patchDebtBase(nodeId, nodeData) {
        return axios.httpApi.patch(`/debt-base/${nodeId}`, nodeData);
    },

    getTree(debtBaseId) {
        let url = `/debt-base/${debtBaseId}/tree`
        
        return axios.httpApi.get(url);
    },

    nodeSimulate(nodeData) {
        let url = `/debt-node/${nodeData.parent_id}/simulate`
        return axios.httpApi.post(url, nodeData);
    },

    patchNode(nodeId, nodeData) {
        let url = `/debt-node/${nodeId}?patch_children=true`
        return axios.httpApi.patch(url, nodeData);
    },

    createNode(nodeData) {
        return axios.httpApi.post('/debt-node', nodeData);
    },

    /**
     * Filtros:
     * [parent, stimulus, children, last_resolution]
     * 
     * @param {*} debtNodeId 
     * @param {*} includes 
     * @returns 
     */
    getNode(debtNodeId, includes = []) {
        let url = "/debt-node/" + debtNodeId
        if (includes.length) url += "?include=" + includes.join(",");
        return axios.httpApi.get(url);
    },

    getNodeHistory(id, limit = 60) {
        return axios.httpApi.get("/debt-node/" + id + "/history?limit=" + limit);
    }

}